<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="part" title="PART 1">
<header>
<p class="h2-p" id="pa1"><span class="right_1" epub:type="pagebreak" id="page_7" title="7"><a href="#/text/nav#rpa1">PART ONE</a></span></p>
<p class="h2-p1"><a href="#/text/nav#rpa1">AMERICAN BORN, BICULTURAL BRED</a></p>
</header>
<p class="epig">昔の剣今の菜刀</p>
<p class="epig"><i>Mukashi no tsurugi ima no na-gatana</i></p>
<p class="epig">Fortune is made of glass.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780062351951_Part_1.vue?46d305e3